/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Creators as SearchActions } from "../../store/ducks/search";
import { OrdenationContext } from "../../contexts/OrdenationContext";
import { FilterContext } from "../../contexts/FilterContext";
import api from "../../services/api";
import { toSlug, humanizeSlug } from "../../util/format";
import { getItemsPerPage } from "../../util/itemsPerPage";
import ButtonPrimary from "../ButtonPrimary";
import CloseRound from "../CloseRound";
import ButtonSecondary from "../ButtonSecondary";
import {
  Container,
  ContainerButton,
  ContainerCheckFilter,
  ContainerCloseRound,
  ContainerFilters,
  ContainerInfoFilter,
  ContentFilter,
  ContainerFiltersSelected,
  Header,
  HeaderTop,
  Title,
  ClearLink,
  InputField,
} from "./styles";

// Definição dos tipos de filtros
const FILTER_TYPES = {
  PROMO: 'desconto',
  LEVE_MAIS: 'leveMaisPagueMenos',
  PRICE: 'preco',
  MANUFACTURER: 'fabricante',
  TYPE: 'tipoProduto',
  CATEGORY: 'categoria',
  SUBCATEGORY: 'subCategoria',
  GENERIC: 'generico',
  IN_STOCK: 'emEstoque',
  PRESCRIPTION: 'receitaMedica',
  STRIPE: 'tarja'
};

// Filtros padrão (sempre disponíveis)
const DEFAULT_FILTERS = [
  {
    id: 'valores',
    title: 'Valores',
    type: 'multi',
    items: [
      { label: 'Promoção', type: FILTER_TYPES.PROMO, value: 'true' },
      { label: 'Leve mais pague menos', type: FILTER_TYPES.LEVE_MAIS, value: 'true' }
    ]
  },
  {
    id: 'preco',
    title: 'Faixa de preço',
    type: 'multi',
    items: [
      { label: 'Até R$ 49,99', type: FILTER_TYPES.PRICE, value: '0', data: { min: 0, max: 49.99 } },
      { label: 'R$ 50,00 a R$ 99,99', type: FILTER_TYPES.PRICE, value: '1', data: { min: 50, max: 99.99 } },
      { label: 'R$ 100,00 a R$ 149,99', type: FILTER_TYPES.PRICE, value: '2', data: { min: 100, max: 149.99 } },
      { label: 'R$ 150,00 a R$ 199,99', type: FILTER_TYPES.PRICE, value: '3', data: { min: 150, max: 199.99 } },
      { label: 'R$ 200,00 a R$ 249,99', type: FILTER_TYPES.PRICE, value: '4', data: { min: 200, max: 249.99 } },
      { label: 'R$ 250,00 a R$ 299,99', type: FILTER_TYPES.PRICE, value: '5', data: { min: 250, max: 299.99 } },
      { label: 'R$ 300,00 a R$ 399,99', type: FILTER_TYPES.PRICE, value: '6', data: { min: 300, max: 399.99 } },
      { label: 'R$ 400,00 a R$ 499,99', type: FILTER_TYPES.PRICE, value: '7', data: { min: 400, max: 499.99 } },
      { label: 'Acima de R$ 500,00', type: FILTER_TYPES.PRICE, value: '8', data: { min: 500, max: null } }
    ]
  },
  {
    id: 'generico',
    title: 'Genérico',
    type: 'multi',
    items: [
      { label: 'Sim', type: FILTER_TYPES.GENERIC, value: 'true' },
      { label: 'Não', type: FILTER_TYPES.GENERIC, value: 'false' }
    ]
  },
  {
    id: 'estoque',
    title: 'Disponibilidade',
    type: 'multi',
    items: [
      { label: 'Em estoque', type: FILTER_TYPES.IN_STOCK, value: 'true' }
    ]
  },
  {
    id: 'receita',
    title: 'Receita médica',
    type: 'multi',
    items: [
      { label: 'Não requer receita', type: FILTER_TYPES.PRESCRIPTION, value: 'false' },
      { label: 'Requer receita', type: FILTER_TYPES.PRESCRIPTION, value: 'true' }
    ]
  },
  {
    id: 'tarja',
    title: 'Tarja',
    type: 'multi',
    items: [
      { label: 'Sem tarja', type: FILTER_TYPES.STRIPE, value: 'nenhuma' },
      { label: 'Tarja vermelha', type: FILTER_TYPES.STRIPE, value: 'vermelha' },
      { label: 'Tarja preta', type: FILTER_TYPES.STRIPE, value: 'preta' }
    ]
  }
];

export default function DropdownFilter({ params, isModal, setIsOpen }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.storeByUser.data);
  const { productsFound } = useSelector((state) => state.search);
  const { ordenation, setOrdenations } = useContext(OrdenationContext);
  const { setFilters, setBreadcrumb } = useContext(FilterContext);

  const [filters, setFiltersState] = useState([...DEFAULT_FILTERS]);
  const [selectedFilters, setSelectedFilters] = useState(new Map());
  const [searchTexts, setSearchTexts] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const lastFilterCall = useRef(null);
  const mountedRef = useRef(true);

  // Evita setState após o desmonte (corrige warning de memory leak)
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // Carrega filtros dinâmicos da API
  useEffect(() => {
    loadDynamicFilters();
  }, [params.ctgId, params.term, store?.uuid]);

  // Sincroniza filtros selecionados com a URL
  useEffect(() => {
    syncFiltersFromUrl();

  }, [window.location.href, store?.uuid]);

  // Re-sincroniza quando filtros dinâmicos carregam (para pegar labels corretos)
  useEffect(() => {
    if (!isLoading && filters.length > DEFAULT_FILTERS.length) {
      syncFiltersFromUrl();
    }
  }, [filters]);

  // Publica os nomes amigáveis da rota atual (categoria/sub/segmento) no contexto,
  // reutilizando o lookup de filtros já carregado. Consumido pelo breadcrumb/título.
  useEffect(() => {
    const findLabel = (groupId, value) => {
      const group = filters.find((f) => f.id === groupId);
      const item = group?.items.find((i) => String(i.value) === String(value));
      return item?.label || "";
    };

    setBreadcrumb({
      category: params.ctgId
        ? findLabel("categorias", params.ctgId) || humanizeSlug(params.ctg)
        : "",
      subcategory: params.subCtgId
        ? findLabel("subcategorias", params.subCtgId) || humanizeSlug(params.subCtg)
        : "",
      segment: params.segId ? humanizeSlug(params.seg) : "",
    });
  }, [filters, params.ctgId, params.ctg, params.subCtgId, params.subCtg, params.segId, params.seg]);

  const loadDynamicFilters = async () => {
    const filterKey = `${params.ctgId}-${params.term}-${store?.uuid}`;
    if (isLoading || lastFilterCall.current === filterKey) return;

    setIsLoading(true);
    lastFilterCall.current = filterKey;

    try {
      const searchTerm = params.term || "";
      const normalizedTerm = searchTerm
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

      const response = await api.post(
        "/products/search/filters",
        {
          termo: normalizedTerm,
          store: store || null,
        },
        {
          params: {
            categoria: params.ctgId || null,
          },
        }
      );

      const newFilters = [...DEFAULT_FILTERS];

      // Fabricantes
      if (response.data.producers?.length > 0) {
        newFilters.push({
          id: 'fabricante',
          title: 'Fabricante',
          type: 'multi',
          searchable: true,
          items: response.data.producers.map((p) => ({
            label: p.fabricante,
            type: FILTER_TYPES.MANUFACTURER,
            value: p.fabricante,
          })),
        });
      }

      // Tipo de Produto
      if (response.data.productTypes?.length > 0) {
        newFilters.push({
          id: 'tipoProduto',
          title: 'Tipo Produto',
          type: 'multi',
          items: response.data.productTypes.map((t) => ({
            label: t.descricao,
            type: FILTER_TYPES.TYPE,
            value: String(t.id),
          })),
        });
      }

      // Categorias (sempre carregar para buscar descrição)
      if (!params.subCtgId && response.data.categories?.length > 0) {
        newFilters.push({
          id: 'categorias',
          title: 'Categorias',
          type: params.ctgId ? 'hidden' : 'navigation', // Oculta se já houver categoria na URL
          items: response.data.categories.map((c) => ({
            label: c.descricao,
            type: FILTER_TYPES.CATEGORY,
            value: c.id,
            data: { slug: toSlug(c.descricao) },
          })),
        });
      }

      // Subcategorias
      if (response.data.subcategories?.length > 0) {
        newFilters.push({
          id: 'subcategorias',
          title: 'Subcategorias',
          type: 'multi',
          items: response.data.subcategories.map((s) => ({
            label: s.descricao,
            type: FILTER_TYPES.SUBCATEGORY,
            value: s.id,
          })),
        });
      }

      if (mountedRef.current) {
        setFiltersState(newFilters);
      }
      // syncFiltersFromUrl será chamado pelo useEffect quando filters mudar
    } catch (error) {
      console.error("Erro ao carregar filtros:", error);
    } finally {
      if (mountedRef.current) {
        setIsLoading(false);
      }
    }
  };

  const syncFiltersFromUrl = () => {
    if (!mountedRef.current) return;

    const queryParams = new URLSearchParams(window.location.search);
    const newSelected = new Map();

    // Extrai o número da página da URL
    const currentPage = parseInt(queryParams.get('page') || '1', 10);
    const limit = getItemsPerPage(); // Responsivo ao tamanho da tela (fonte única do page size)
    const offset = (currentPage - 1) * limit;

    // Lê a ordenação da URL e sincroniza com o contexto
    const urlOrdering = queryParams.get('ordering') || 'relevancia';
    if (urlOrdering && urlOrdering !== ordenation) {
      setOrdenations(urlOrdering);
    }

    // Sincroniza filtros da URL (query params)
    filters.forEach((filterGroup) => {
      filterGroup.items.forEach((item) => {
        const paramValues = queryParams.getAll(item.type);
        if (paramValues.includes(String(item.value))) {
          const key = `${item.type}-${item.value}`;
          // Garante que todas as propriedades sejam copiadas, incluindo 'data' dos filtros de preço
          const filterData = {
            label: item.label,
            type: item.type,
            value: item.value,
            groupId: filterGroup.id
          };

          // Se o item tem dados adicionais (como min/max de preço), inclui
          if (item.data) {
            filterData.data = { ...item.data };
          }

          newSelected.set(key, filterData);
        }
      });
    });

    // Adiciona categoria da URL de navegação (params.ctgId)
    // SEMPRE adiciona, mesmo se os filtros ainda não foram carregados
    if (params.ctgId) {
      const categoryGroup = filters.find(f => f.id === 'categorias');
      const categoryItem = categoryGroup?.items.find(item => String(item.value) === String(params.ctgId));

      const key = `${FILTER_TYPES.CATEGORY}-${params.ctgId}`;
      if (categoryItem) {
        // Se encontrou na lista de filtros, usa o label da API
        newSelected.set(key, {
          label: categoryItem.label,
          type: FILTER_TYPES.CATEGORY,
          value: params.ctgId,
          groupId: 'categorias'
        });
      } else {
        // Se ainda não carregou, usa o slug da URL como fallback
        newSelected.set(key, {
          label: params.ctg ? decodeURIComponent(params.ctg).replace(/-/g, ' ') : 'Categoria',
          type: FILTER_TYPES.CATEGORY,
          value: params.ctgId,
          groupId: 'categorias'
        });
      }
    }
      dispatch(
      SearchActions.setSearchFilters(
        Array.from(newSelected.values()).filter(filter => filter.type !== FILTER_TYPES.CATEGORY),
        params.term || "",
        urlOrdering,
        params.ctgId || null,
        params.subCtgId || null,
        params.segId || null,
        false,
        offset,
        limit
      )
    );

    // Subcategorias vêm dos query params, já foram sincronizadas acima
    setSelectedFilters(newSelected);

    window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
  };

  const toggleFilter = (filterGroup, item) => {
    // Navegação para categoria
    if (filterGroup.type === 'navigation' && item.type === FILTER_TYPES.CATEGORY) {
      // Preserva a ordenação ao navegar para categoria
      const newParams = new URLSearchParams();
      newParams.set('page', '1');
      if (ordenation) {
        newParams.set('ordering', ordenation);
      }
      history.push(`/produtos/categoria/${item.data.slug}/${item.value}?${newParams.toString()}`);
      return;
    }

    const key = `${item.type}-${item.value}`;
    const newSelected = new Map(selectedFilters);

    // Se for single choice, remove outros do mesmo grupo
    if (filterGroup.type === 'single') {
      Array.from(newSelected.keys()).forEach((k) => {
        const filter = newSelected.get(k);
        if (filter.groupId === filterGroup.id) {
          newSelected.delete(k);
        }
      });
    }

    // Toggle do item
    if (newSelected.has(key)) {
      newSelected.delete(key);
    } else {
      newSelected.set(key, { ...item, groupId: filterGroup.id });
    }

    setSelectedFilters(newSelected);
    updateUrl(newSelected);
  };

  const removeFilter = (key) => {
    const filter = selectedFilters.get(key);

    // Se remover categoria da navegação, redireciona
    if (filter && filter.type === FILTER_TYPES.CATEGORY) {
      const term = params.term ? `/${params.term}` : '';

      // Preserva os query params da URL atual (exceto categoria)
      const currentParams = new URLSearchParams(window.location.search);
      const newParams = new URLSearchParams();

      // Define page e ordering com valores fixos
      newParams.set('page', '1');
      newParams.set('ordering', 'relevancia');

      // Copia todos os outros parâmetros (exceto page, ordering e categoria)
      currentParams.forEach((value, key) => {
        if (key !== 'page' && key !== 'ordering' && key !== FILTER_TYPES.CATEGORY) {
          newParams.append(key, value);
        }
      });

      history.push(`/produtos/buscar${term}?${newParams.toString()}`);
      return;
    }

    const newSelected = new Map(selectedFilters);
    newSelected.delete(key);
    setSelectedFilters(newSelected);
    updateUrl(newSelected);
  };

  const clearAllFilters = () => {
    setSelectedFilters(new Map());

    // Preserva a ordenação ao limpar filtros
    const newParams = new URLSearchParams();
    newParams.set('page', '1');
    if (ordenation) {
      newParams.set('ordering', ordenation);
    }

    history.push(`/produtos/buscar?${newParams.toString()}`);
  };

  const updateUrl = (selected) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();

    // Reseta a paginação para página 1
    params.set('page', '1');

    // Adiciona a ordenação se existir
    if (ordenation) {
      params.set('ordering', ordenation);
    }

    // Agrupa filtros por tipo (EXCLUINDO apenas categoria que é param de rota)
    const filtersByType = new Map();
    selected.forEach((filter) => {
      // Ignora APENAS categoria - ela vem da URL de navegação (/produtos/categoria/...)
      // Subcategoria vai para query string normalmente
      if (filter.type === FILTER_TYPES.CATEGORY) {
        return;
      }

      if (!filtersByType.has(filter.type)) {
        filtersByType.set(filter.type, []);
      }
      filtersByType.get(filter.type).push(filter.value);
    });

    // Adiciona na URL
    filtersByType.forEach((values, type) => {
      values.forEach((value) => params.append(type, value));
    });

    url.search = params.toString();
    window.history.pushState(null, "", url.toString());
  };

  const triggerSearch = () => {
    // Remove categoria do array de filtros (ela vem de params.ctgId, não de filtros)
    const filtersArray = Array.from(selectedFilters.values())
      .filter(filter => filter.type !== FILTER_TYPES.CATEGORY);

    setFilters(filtersArray);

    // Extrai o número da página da URL
    const queryParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(queryParams.get('page') || '1', 10);
    const limit = getItemsPerPage(); // Responsivo ao tamanho da tela (fonte única do page size)
    const offset = (currentPage - 1) * limit;

    dispatch(
      SearchActions.setSearchFilters(
        filtersArray,
        params.term || "",
        ordenation,
        params.ctgId || null,
        params.subCtgId || null,
        params.segId || null,
        false,
        offset,
        limit
      )
    );
  };

  const applyFilters = () => {
    if (isModal) {
      triggerSearch();
      setIsOpen();
    }
  };

  const getFilteredItems = (filterGroup) => {
    if (!filterGroup.searchable) return filterGroup.items;

    const searchText = (searchTexts[filterGroup.id] || "").toLowerCase();
    return filterGroup.items.filter((item) =>
      item.label.toLowerCase().includes(searchText)
    );
  };

  const isFilterSelected = (item) => {
    const key = `${item.type}-${item.value}`;
    return selectedFilters.has(key);
  };

  return (
    <Container id="dropdownContainer" isModal={isModal}>
      {isModal && (
        <ContainerCloseRound>
          <CloseRound onClick={setIsOpen} className="closeRound" />
        </ContainerCloseRound>
      )}

      <ContainerInfoFilter hasPadding={isModal}>
        <HeaderTop>
          <Title>Filtros</Title>
          {selectedFilters.size > 0 && (
            <ClearLink type="button" onClick={clearAllFilters}>
              Limpar
            </ClearLink>
          )}
        </HeaderTop>

        {/* Filtros Selecionados */}
        {selectedFilters.size > 0 && (
          <ContainerFiltersSelected>
            <span>Filtros Selecionados</span>
            <ul>
              {Array.from(selectedFilters.entries()).map(([key, filter]) => (
                <li key={key}>
                  <span>{filter.label}</span>
                  <button
                    type="button"
                    onClick={() => {
                      removeFilter(key);
                    }}
                  >
                    &times;
                  </button>
                </li>
              ))}
            </ul>
            <button
              className="cleanAll"
              type="button"
              onClick={() => {
                clearAllFilters();
              }}
            >
              Limpar todos
            </button>
          </ContainerFiltersSelected>
        )}

        {/* Lista de Filtros */}
        <ContainerFilters>
          {filters.map((filterGroup, index) => {
            const filteredItems = getFilteredItems(filterGroup);
            if (filteredItems.length === 0 || filterGroup.type === 'hidden') return null;

            return (
              <div key={filterGroup.id}>
                <ContentFilter>
                  <Header>{filterGroup.title}</Header>

                  {filterGroup.searchable && (
                    <InputField
                      type="text"
                      placeholder="Buscar..."
                      value={searchTexts[filterGroup.id] || ""}
                      onChange={(e) =>
                        setSearchTexts({
                          ...searchTexts,
                          [filterGroup.id]: e.target.value,
                        })
                      }
                    />
                  )}

                  <div className="items div-custom-scroll">
                    {filteredItems.map((item, itemIndex) => (
                      <ContainerCheckFilter
                        key={`${filterGroup.id}-${itemIndex}`}
                        selected={isFilterSelected(item)}
                      >
                        <input
                          id={`filter-${filterGroup.id}-${itemIndex}`}
                          type="checkbox"
                          checked={isFilterSelected(item)}
                          onChange={() => toggleFilter(filterGroup, item)}
                        />
                        <label htmlFor={`filter-${filterGroup.id}-${itemIndex}`}>
                          {item.label}
                        </label>
                      </ContainerCheckFilter>
                    ))}
                  </div>
                </ContentFilter>
              </div>
            );
          })}
        </ContainerFilters>
      </ContainerInfoFilter>

      {isModal && (
        <ContainerButton>
          <ButtonPrimary
            className="buttonFilter"
            text="Aplicar filtros"
            disabled={selectedFilters.size === 0}
            onClick={applyFilters}
          />
          <ButtonSecondary
            className="buttonFilter"
            text="Limpar filtros"
            disabled={selectedFilters.size === 0}
            onClick={clearAllFilters}
          />
        </ContainerButton>
      )}
    </Container>
  );
}
